// 统一的工具函数文件，用于在多个组件中共享功能

(function () {
  const cartDrawerFormInstance = null;

  // 打开购物车弹窗
  async function openCartDrawer() {
    // const drawerForm = document.querySelector('#CartDrawerForm');
    // if (drawerForm && window.theme?.CartForm) {
    //   if (!cartDrawerFormInstance) {
    //     cartDrawerFormInstance = new window.theme.CartForm(drawerForm);
    //   }
    //   await cartDrawerFormInstance.buildCart();
    // }
    // document.dispatchEvent(new CustomEvent('cart:open'));
    // 模拟按钮点击
    var cartButtons = document.querySelectorAll('.js-custom-cart-open');
    if (cartButtons && cartButtons.length > 0) {
      cartButtons[0].click();
    }
  }

  const ANONYMOUS_ID_KEY = '_anonymous_id';

  function getAnonymousId() {
    const localAnonymousId = localStorage.getItem(ANONYMOUS_ID_KEY);
    if (localAnonymousId) return localAnonymousId;

    const cookieAnonymousId = document.cookie.match(
      /(?:^|;\s*)_shopify_y=([^;]+)/,
    )?.[1];
    const anonymousId =
      cookieAnonymousId ||
      `${Math.random().toString(36).slice(2)}-${Date.now()}`;
    localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId);
    return anonymousId;
  }

  // 获取用户身份信息
  function getIdentity() {
    const customerId = window.theme?.customerId
      ? `${window.theme.customerId}`
      : undefined;
    const anonymousId = getAnonymousId();
    return {
      ...(customerId ? { customerId: String(customerId) } : {}),
      ...(anonymousId ? { anonymousId } : {}),
    };
  }

  /**
   * 测试环境覆盖远程下发
   */
  function overrideExperiment(experimentName) {
    const overrideData = JSON.parse(
      localStorage.getItem('_statsig_override') || '{}',
    );
    return new Promise((resolve) => {
      const exp = {
        get: (key, defaultValue) => {
          return overrideData[experimentName]?.[key] ?? defaultValue;
        },
      };
      resolve(exp);
    });
  }

  let membershipCartEntryPromise;

  const MEMBERSHIP_CART_ENTRY_GROUP_IDS = {
    false: 85,
    true: 86,
  };

  function recordMembershipCartEntryGroup(value) {
    if (typeof value !== 'boolean') return;
    const groupId = MEMBERSHIP_CART_ENTRY_GROUP_IDS[String(value)];
    if (groupId === undefined) return;
    window.zlog?.recordExperimentGroup?.(
      'membership_cart_entry:enable',
      groupId,
    );
  }

  // 只由实际可见的购物车调用；预加载不触发实验曝光，同页共用结果。
  function getMembershipCartEntryEnabled() {
    if (!membershipCartEntryPromise) {
      membershipCartEntryPromise = Promise.resolve()
        .then(async () => {
          const name = 'membership_cart_entry';
          const isTest =
            window.location.hostname.includes('127.0.0.1') ||
            window.location.hostname.includes('shopifypreview.com') ||
            localStorage.getItem('_shop_mode') === 'test';
          const experiment =
            isTest && window.jjbUtils?.overrideExperiment
              ? await window.jjbUtils.overrideExperiment(name)
              : (await window.statsigReady,
                await window.statsigClient?.getExperiment(name));
          const enabled = experiment?.get('enable', false);
          recordMembershipCartEntryGroup(enabled);
          return enabled === true;
        })
        .catch(() => false);
    }
    return membershipCartEntryPromise;
  }

  const MEMBERSHIP_ENTRY_REDIRECT_EXPERIMENT = 'membership_entry_redirect';
  const MEMBERSHIP_ENTRY_REDIRECT_KEY = `${MEMBERSHIP_ENTRY_REDIRECT_EXPERIMENT}:enable`;
  const MEMBERSHIP_ENTRY_REDIRECT_GROUP_IDS = { false: 93, true: 94 };
  const MEMBERSHIP_ENTRY_REDIRECT_PARAM = 'membership_entry_redirect_group';
  const MEMBERSHIP_ENTRY_REDIRECT_SOURCES = new Set([
    'generate_create', 'generate_gallery', 'cart_half', 'cart_whole', '40_generate', '25_generate',
  ]);
  let membershipEntryRedirectPromise;
  let membershipEntryRedirectRestored = false;

  // 只有点击目标入口才读取；同页跨画板、购物车共用首次结果。
  function resolveMembershipEntryRedirect(entryPage) {
    if (!MEMBERSHIP_ENTRY_REDIRECT_SOURCES.has(entryPage)) {
      return Promise.resolve({ enabled: false });
    }
    if (!membershipEntryRedirectPromise) {
      membershipEntryRedirectPromise = (async () => {
        let timer;
        try {
          const request = Promise.resolve().then(async () => {
            const isTest =
              window.__RELEASE__?.isTest === true ||
              window.location.hostname.includes('127.0.0.1') ||
              window.location.hostname.includes('shopifypreview.com') ||
              localStorage.getItem('_shop_mode') === 'test';
            const experiment =
              isTest && window.jjbUtils?.overrideExperiment
                ? await window.jjbUtils.overrideExperiment(
                    MEMBERSHIP_ENTRY_REDIRECT_EXPERIMENT,
                  )
                : (await window.statsigReady,
                  await window.statsigClient?.getExperiment(
                    MEMBERSHIP_ENTRY_REDIRECT_EXPERIMENT,
                  ));
            // 缺失不能默认成合法 false，否则会伪造成功对照分组。
            return experiment?.get('enable', undefined);
          });
          const value = await Promise.race([
            request,
            new Promise((resolve) => {
              timer = window.setTimeout(() => resolve(undefined), 2000);
            }),
          ]);
          if (typeof value !== 'boolean') return { enabled: false };
          const groupId = MEMBERSHIP_ENTRY_REDIRECT_GROUP_IDS[String(value)];
          window.zlog?.recordExperimentGroup?.(
            MEMBERSHIP_ENTRY_REDIRECT_KEY,
            groupId,
          );
          return { enabled: value, groupId };
        } catch (_) {
          return { enabled: false };
        } finally {
          window.clearTimeout(timer);
        }
      })();
    }
    return membershipEntryRedirectPromise;
  }

  async function openMembershipEntry({
    entry_page: entryPage,
    fallback_url: fallbackUrl,
    beforeOpen,
  }) {
    const result = await resolveMembershipEntryRedirect(entryPage);
    // 原调用方提供自己的埋点，保留各入口参数与平台，且分组先于点击事件。
    await beforeOpen?.();
    if (!result.enabled) {
      try {
        if (window.jjbMembershipPopup?.open({ entry_page: entryPage }))
          return 'popup';
      } catch (_) {}
    }
    let target = fallbackUrl;
    if (result.enabled || result.groupId !== undefined) {
      const url = new URL(fallbackUrl, window.location.href);
      if (result.enabled) {
        url.pathname = '/pages/vip-program';
        url.searchParams.set('tab', 'plans');
        url.searchParams.set('entry_page', entryPage);
      }
      url.searchParams.set(
        MEMBERSHIP_ENTRY_REDIRECT_PARAM,
        String(result.groupId),
      );
      target = `${url.pathname}${url.search}${url.hash}`;
    }
    window.zlog?.flushTracking?.();
    window.location.assign(target);
    return 'fullscreen';
  }

  // 仅恢复归因，不重新分流；该参数不会影响会员页原有权限开关。
  function restoreMembershipEntryRedirectGroup() {
    if (
      membershipEntryRedirectRestored ||
      window.location.pathname !== '/pages/vip-program'
    )
      return;
    const params = new URLSearchParams(window.location.search);
    if (!MEMBERSHIP_ENTRY_REDIRECT_SOURCES.has(params.get('entry_page')))
      return;
    const value = params.get(MEMBERSHIP_ENTRY_REDIRECT_PARAM);
    if (value !== '93' && value !== '94') return;
    if (!window.zlog?.recordExperimentGroup) return;
    window.zlog.recordExperimentGroup(
      MEMBERSHIP_ENTRY_REDIRECT_KEY,
      Number(value),
    );
    membershipEntryRedirectRestored = true;
  }

  const MEMBERSHIP_PAYWALL_VISUAL_EXPERIMENT = 'membership_paywall_visual';
  const MEMBERSHIP_PAYWALL_VISUAL_KEY = `${MEMBERSHIP_PAYWALL_VISUAL_EXPERIMENT}:enable`;
  const MEMBERSHIP_PAYWALL_VISUAL_GROUP_IDS = { false: 101, true: 102 };
  let membershipPaywallVisualPromise;

  // 半屏与全屏会员墙共用页面生命周期内的首次结果，避免重复曝光或显示后闪切。
  function resolveMembershipPaywallVisual() {
    if (!membershipPaywallVisualPromise) {
      membershipPaywallVisualPromise = (async () => {
        let timer;
        try {
          const request = Promise.resolve().then(async () => {
            const isTest =
              window.__RELEASE__?.isTest === true ||
              window.location.hostname.includes('127.0.0.1') ||
              window.location.hostname.includes('shopifypreview.com') ||
              localStorage.getItem('_shop_mode') === 'test';
            const experiment =
              isTest && window.jjbUtils?.overrideExperiment
                ? await window.jjbUtils.overrideExperiment(
                    MEMBERSHIP_PAYWALL_VISUAL_EXPERIMENT,
                  )
                : (await window.statsigReady,
                  await window.statsigClient?.getExperiment(
                    MEMBERSHIP_PAYWALL_VISUAL_EXPERIMENT,
                  ));
            return experiment?.get('enable', undefined);
          });
          const value = await Promise.race([
            request,
            new Promise((resolve) => {
              timer = window.setTimeout(() => resolve(undefined), 2000);
            }),
          ]);
          if (typeof value !== 'boolean') {
            return { variant: 'legacy', enabled: false };
          }
          const groupId = MEMBERSHIP_PAYWALL_VISUAL_GROUP_IDS[String(value)];
          window.zlog?.recordExperimentGroup?.(
            MEMBERSHIP_PAYWALL_VISUAL_KEY,
            groupId,
          );
          return {
            variant: value ? 'visual' : 'legacy',
            enabled: value,
            groupId,
          };
        } catch (_) {
          return { variant: 'legacy', enabled: false };
        } finally {
          window.clearTimeout(timer);
        }
      })();
    }
    return membershipPaywallVisualPromise;
  }

  function applyMembershipPaywallVisual(root, variant) {
    if (!root) return null;
    const selected = variant === 'visual' ? 'visual' : 'legacy';
    let active = null;
    root.dataset.membershipVisualVariant = selected;
    root
      .querySelectorAll('[data-membership-visual-variant]')
      .forEach((container) => {
        const enabled = container.dataset.membershipVisualVariant === selected;
        container.hidden = !enabled;
        container.inert = !enabled;
        if (enabled) {
          container.removeAttribute('aria-hidden');
          active = container;
        } else {
          container.setAttribute('aria-hidden', 'true');
        }
      });
    return active;
  }

  window.jjbUtils = {
    overrideExperiment,
    getMembershipCartEntryEnabled,
    openMembershipEntry,
    restoreMembershipEntryRedirectGroup,
    resolveMembershipPaywallVisual,
    applyMembershipPaywallVisual,
    openCartDrawer,
    getIdentity,
  };
})();
